// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"115":"bf117663","159":"f7f2b62f","348":"2521cd31","618":"6c73221c","641":"5edeb477"}[chunkId] + ".chunk.js";
};